import { AnswerValue } from "@/commonTypes/answer";

/**
 * Extracts a string answer value, returning empty string if type doesn't match.
 * Used for TEXT and DATE_PICKER question types.
 */
export function getStringAnswer(answer: AnswerValue | null): string {
  return typeof answer === "string" ? answer : "";
}

/**
 * Extracts a string or string[] answer value, returning null if type doesn't match.
 * Used for MULTIPLE_CHOICE question type.
 */
export function getMultipleChoiceAnswer(
  answer: AnswerValue | null
): string | string[] | null {
  if (answer === null) return null;
  if (typeof answer === "string") return answer;
  if (Array.isArray(answer)) return answer;
  return null;
}

/**
 * Extracts a Record<string, string> answer value, returning empty object if type doesn't match.
 * Used for TEXT_GROUP question type.
 */
export function getTextGroupAnswer(
  answer: AnswerValue | null
): Record<string, string> {
  if (answer !== null && typeof answer === "object" && !Array.isArray(answer)) {
    return answer;
  }
  return {};
}

